export default "__VITE_ASSET__BmP62BQ2__"